import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../../config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./employeePrint.css";

const EmployeeOverallReport = () => {
  const { requestId } = useParams();
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [emp, setEmp] = useState(null);
  const [rows, setRows] = useState([]);
{new Date(emp.appraisal_month).toLocaleString("en-IN", {
  month: "long",
  year: "numeric",
})}

  // ✅ BACKEND PUBLIC IMAGE URL (NO IMPORT)
  const LOGO_URL = `${API_BASE_URL.replace(
    "/api",
    ""
  )}/uploads/logo/favicon/aaps.jpg`;

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/employees-appraisal/overall-report/${requestId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((res) => {
        setEmp(res.data.employee);
        setRows(res.data.questions || []);
        setLoading(false);
      })
      .catch(() => {
        toast.error("Failed to load report");
        history.push("/EmployeesAppraisalList");
      });
  }, [requestId, history]);

  if (loading) return null;
  if (!emp) return null;

  return (
    <div className="container-fluid">
      <ToastContainer />

      {/* ===== ACTION BAR (NOT PRINTED) ===== */}
      <div className="card mb-3 no-print">
        <div className="card-body d-flex justify-content-between">
          <h5>Employee Appraisal – Overview Report</h5>
          <div>
            <button
              className="btn btn-secondary mr-2"
              onClick={() => history.push("/EmployeesAppraisalList")}
            >
              Back
            </button>
            <button
              className="btn btn-primary"
              onClick={() => window.print()}
            >
              Print
            </button>
          </div>
        </div>
      </div>

      {/* ===== PRINT AREA ===== */}
      <div id="print-area">

        {/* ===== HEADER ===== */}
        <div className="print-header">
          <div className="logo-box">
            <img src={LOGO_URL} alt="" />
          </div>

          <div className="title-box">
            <h2>Annai Arul Public School</h2>
            <h4>Performance Appraisal Score Sheet</h4>
          </div>
        </div>

        {/* ===== EMPLOYEE DETAILS ===== */}
        <table className="info-table">
          <tbody>
            <tr>
              <td><b>Employee Name</b> : {emp.emp_name}</td>
              <td><b>Employee ID</b> : {emp.employee_id}</td>
            </tr>
            <tr>
              <td><b>Designation</b> : {emp.designation_name}</td>
              <td><b>Date Of Joining</b> : {emp.date_of_joining}</td>
            </tr>
            <tr>
              <td><b>Department</b> : {emp.department_name}</td>
              <td><b>Month Of Appraisal</b> : {emp.appraisal_month}</td>
            </tr>
          </tbody>
        </table>

        {/* ===== SCORE TABLE ===== */}
        <div className="table-scroll">
        <table className="score-table">
          <thead>
            <tr>
              <th>S.N</th>
              <th>Questions</th>
              <th>Self</th>
              <th>Incharge</th>
              <th>HOD</th>
              <th>HR</th>
              <th>Management</th>
              <th>Others</th>
              <th>Total</th>
              <th>Average</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => {
              const scores = [
                r.self,
                r.incharge,
                r.hod,
                r.hr,
                r.management,
                r.others,
              ].filter(v => v !== null && v !== undefined);

              const total = scores.reduce((a, b) => a + b, 0);
              const avg = scores.length
                ? Math.round(total / scores.length)
                : "--";

              return (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td className="text-left">{r.question_title}</td>
                  <td>{r.self ?? "--"}</td>
                  <td>{r.incharge ?? "--"}</td>
                  <td>{r.hod ?? "--"}</td>
                  <td>{r.hr ?? "--"}</td>
                  <td>{r.management ?? "--"}</td>
                  <td>{r.others ?? "--"}</td>
                  <td>{total || "--"}</td>
                  <td>{avg}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        </div>

      </div>
    </div>
  );
};

export default EmployeeOverallReport;
